import styled from "styled-components";
import { theme } from "../../../styles/theme";

export const BlockInput = styled.div`
  width: 100%;
  margin: 0.5rem 0px;
  position: relative;
  
  select {
    appearance: none;
    -webkit-appearance: none;
    display: block;
    background-color: #ffffff;
    color: #1f2937;
    border: 1.5px solid ${theme.colors.borderStrong};
    box-sizing: border-box;
    border-radius: 8px;
    padding: 0 2.5rem 0 1rem;
    height: 48px;
    width: 100%;
    font-size: 1rem;
    cursor: pointer;
    outline: none;
    transition: border-color 0.2s, box-shadow 0.2s;
    background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='16' height='16' viewBox='0 0 24 24' fill='none' stroke='%2364748b' stroke-width='2' stroke-linecap='round' stroke-linejoin='round'%3E%3Cpath d='m6 9 6 6 6-6'/%3E%3C/svg%3E");
    background-repeat: no-repeat;
    background-position: right 1rem center;

    &:focus {
      border-color: ${theme.colors.primary};
      box-shadow: 0 0 0 3px rgba(236, 103, 38, 0.2);
    }
  }
`;

export const Label = styled.label<{ $color?: string }>`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
  font-size: 14px;
  line-height: 15px;
  color: ${({ $color }) => $color || "#343a40"};
  font-weight: bold;
  width: 100%;
  margin: 0;
  margin-bottom: 5px;
`;

export const RequiredLabel = styled.span`
  color: ${theme.colors.primary};
  font-size: 0.72rem;
  font-weight: 700;
  line-height: 1;
  white-space: nowrap;
`;

export const ErrorText = styled.span`
  color: #e53e3e;
  font-size: 0.875rem;
  margin-top: 10px;
  display: block;
  font-weight: normal;
`;
